// Import the functions you need from the SDKs you need
import { initializeApp, getApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration


const firebaseConfig = {
  apiKey: "AIzaSyD5u9mvfso8CP4xSwUXiEw4n1dQdwK5aZs",
  authDomain: "backend-site-efg-bb71c.firebaseapp.com",
  projectId: "backend-site-efg-bb71c",
  storageBucket: "backend-site-efg-bb71c.firebasestorage.app",
  messagingSenderId: "396364717792",
  appId: "1:396364717792:web:21b036004dd8e336973a85"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;